// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3680Q","title":"styles_title__2LBkw","roadMap":"styles_roadMap__2DuOC","mobileRoadMap":"styles_mobileRoadMap__1lKZr","arrow":"styles_arrow__3Bjeu"};